"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableListItem = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var colors_1 = require("../../theme/colors");
var text_1 = require("../text");
var text_link_1 = require("../text-link");
function ExpandableListItem(_a) {
    var children = _a.children, href = _a.href, _b = _a.nowrap, nowrap = _b === void 0 ? false : _b, _c = _a.weight, weight = _c === void 0 ? 600 : _c, onClick = _a.onClick, testId = _a.testId;
    var TextComponent = onClick ? text_link_1.TextLink : text_1.Text;
    return (react_1.default.createElement(TextComponent, { style: { display: 'block' }, underline: !!onClick, weight: weight, href: href, colorOnHover: colors_1.colors.brand[400], variant: "secondary", onClick: onClick, nowrap: nowrap, testId: testId }, children));
}
exports.ExpandableListItem = ExpandableListItem;
//# sourceMappingURL=expandable-list-item.js.map